import React, { useEffect, useState } from "react";
import { DataGrid } from "@mui/x-data-grid";
import { Button } from "@mui/material";
import { CSVLink } from "react-csv";

export const SalesData = () => {
  const [rows, setRows] = useState([]);
  const [columns, setColumns] = useState([]);

  useEffect(() => {
    fetch("/api/sales-data")      
      .then((res) => res.json())
      .then((data) => {
        if (data.length === 0) return;

        setRows(data);
        const cols = Object.keys(data[0]).map((key) => ({
          field: key,
          headerName: key
            .replace(/_/g, " ")
            .replace(/\b\w/g, (c) => c.toUpperCase()),
          width: 150,
        }));
        setColumns(cols);
      })
      .catch((err) => console.error("Failed to fetch sales data", err));
  }, []);

  return (
    <div style={{ height: 600, width: "100%" }}>
      <DataGrid rows={rows} columns={columns} pageSize={10} />
      <CSVLink data={rows} filename={"sales_data.csv"}>
        <Button variant="contained" color="primary" style={{ marginTop: 20 }}>
          Export to CSV
        </Button>
      </CSVLink>
    </div>
  );
};

export default SalesData;